<section class="sh-dashboard-content-template__row">
  <div class="sh-dashboard-panel">
    <digihaven-dashboard-title
      [title]="'dashboard.notifications.title' | translate"
      [icon]="'notification'"
      [totalItems]="totalItems$ | async"
      [navigationLink]="navigationLink"
    ></digihaven-dashboard-title>
    <div class="sh-data-table-wrapper">
      <table class="sh-data-table">
        <thead>
          <tr>
            <th scope="col" width="10%">{{ "notifications.table.columns.date" | translate }}</th>
            <th scope="col" width="50%">{{ "notifications.table.columns.name" | translate }}</th>
            <th scope="col" width="35%">{{ "notifications.table.columns.notification" | translate }}</th>
            <th scope="col" width="5%"></th>
          </tr>
        </thead>
        <tbody>
          @if (loading$ | async) {
            <tr>
              <td [colSpan]="COLUMN_COUNT">{{ "ui.loading" | translate }}</td>
            </tr>
          }

          @if (!(loading$ | async) && !(error$ | async) && (notifications$ | async)?.length === 0) {
            <tr>
              <td [colSpan]="COLUMN_COUNT">{{ "notifications.messages.empty-list" | translate }}</td>
            </tr>
          }

          @if (error$ | async) {
            <tr class="sh-card-table__row--error">
              <td [colSpan]="COLUMN_COUNT">{{ "notifications.messages.failed-to-fetch" | translate }}</td>
            </tr>
          }

          @if (!(loading$ | async) && !(error$ | async) && (notifications$ | async)?.length > 0) {
            @for (notification of notifications$ | async; track notification) {
              <tr [class.-sh-emphasise]="notification.New">
                <td>{{ notification.SentOn | readableDate }}</td>
                <th scope="row" [id]="notification.Id">
                  @if (!(notification | isDeleteNotification)) {
                    <a
                      class="sh-list-row-title sh-link"
                      [shNavigationLink]="getNavigationLink(notification)"
                      >
                      <h3 class="sh-list-row-title__title sh-truncate-text">{{ notification.Body }}</h3>
                    </a>
                  } @else {
                    <div class="sh-list-row-title">
                      <h3 class="sh-list-row-title__title sh-truncate-text">{{ notification.Body }}</h3>
                    </div>
                  }
                </th>
                <td>{{ notification.Title }}</td>
                <td>
                  <button
                    type="button"
                    class="sh-button--ghost sh-pure-icon-button"
                    (click)="deleteNotification(notification)"
                    aria-label="close"
                    >
                    <svg sh-icon class="sh-icon sh-icon-button__icon" aria-hidden="true" [name]="'close'"></svg>
                  </button>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  </div>
</section>
